var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return !_vm.isClicked ? _c('div', {
    ref: "message",
    staticClass: "follow-invitation-message"
  }, [_c('span', {
    staticClass: "wrapper"
  }, [_c('button', {
    staticClass: "follow-button",
    on: {
      "click": _vm.followHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('liveroom.subscribe')))])]), _vm._v(" "), _c('span', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.data.content))])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };